import * as CONST from './const'
import { apiClient } from './../../Module/API/Client'
import createMiddleware from './../createMiddleware'
import {
  unbookMission,
  getMissionViewDataById,
  createMissions,
  updateMission,
} from '../../Module/graphQL/index'

export const createMissionsMiddleware = ({ dispatch }) => {
  var hijackedDispatch = action => {
    // Do a sneaky mutation so we don't have to refactor the reducers to work
    // with the different graphQL returned format
    // Can be sorted out properly when the publish REST
    // endpoint call is removed too
    // TODO
    if (action.type === CONST.CREATE_MISSIONS_SUCCESS) {
      action.result = action.missions.map(m => {
        m.cityPlanId = m.cityPlan.id
        delete m.cityPlan
        return m
      })
    }

    return dispatch(action)
  }

  return createMiddleware({
    actions: [
      CONST.CREATE_MISSIONS,
      CONST.CREATE_MISSIONS_SUCCESS,
      CONST.CREATE_MISSIONS_FAILURE,
    ],
    fetchMethod: async (authToken, { missions }) =>
      createMissions({ missions }),
    isOptimistic: false,
  })({ dispatch: hijackedDispatch })
}

export const deleteMissionsMiddleware = createMiddleware({
  actions: [
    CONST.DELETE_MISSIONS,
    CONST.DELETE_MISSIONS_SUCCESS,
    CONST.DELETE_MISSIONS_FAILURE,
  ],
  fetchMethod: (authToken, payload) => apiClient.deleteMissions(payload),
  isOptimistic: false,
})

export const publishMissionsMiddleware = createMiddleware({
  actions: [
    CONST.PUBLISH_MISSIONS,
    CONST.PUBLISH_MISSIONS_SUCCESS,
    CONST.PUBLISH_MISSIONS_FAILURE,
  ],
  fetchMethod: (authToken, { missions }) => apiClient.publishMissions(missions),
  isOptimistic: false,
})

export const unbookMissionsMiddleware = createMiddleware({
  actions: [
    CONST.UNBOOK_MISSION_BY_ID,
    CONST.UNBOOK_MISSION_BY_ID_SUCCESS,
    CONST.UNBOOK_MISSION_BY_ID_FAILURE,
  ],
  fetchMethod: (authToken, { missionId, unbookReason }) =>
    unbookMission(authToken, { missionId, unbookReason }),
  isOptimistic: false,
})

export const getMissionByIdMiddleware = createMiddleware({
  actions: [
    CONST.GET_MISSION_BY_ID_GRAPH_QL,
    CONST.GET_MISSION_BY_ID_GRAPH_QL_SUCCESS,
  ],
  fetchMethod: (authToken, { missionId, unbookReason }) =>
    getMissionViewDataById(missionId),
  isOptimistic: false,
})

export const updateMissionMiddleware = createMiddleware({
  actions: [CONST.UPDATE_MISSION, CONST.UPDATE_MISSION_SUCCESS],
  fetchMethod: (authToken, { mission }) =>
    updateMission({ missionInput: mission }),
  isOptimistic: false,
})
